import { createRouter, createWebHashHistory } from 'vue-router'
import MainView from "@/views/MainView.vue"
import AdminView from "@/views/AdminView.vue"
import HedgeAssistView from "@/views/HedgeAssistView.vue"
import EmpireWargamesView from "@/views/EmpireWargamesView.vue"
import IronhedgeBookView from "@/views/ironhedgebookview.vue"
import StarCitizenView from "@/views/StarCitizenView.vue"
import IronhedgeBook from "@/views/book/iron/ironhedge_book.vue";
import TaoTeChingView from "@/views/TaoTeChingView.vue";
import TopicView from "@/views/TopicView.vue";
import PostView from "@/views/PostView.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: MainView
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/tao',
    name: 'tao',
    component: TaoTeChingView
  },
  {
    path: '/topic/:slug',
    name: 'topic',
    component: TopicView
  },
  {
    path: '/post/:slug',
    name: 'post',
    component: PostView
  },
  {
    path: '/EmpireWargames',
    name: 'EmpireWargames',
    component: EmpireWargamesView
  },
  {
    path: '/BookViewIron',
    name: 'BookViewIron',
    component: IronhedgeBook
  },
  {
    path: '/hedge_assist',
    name: 'hedge_assist',
    component: HedgeAssistView
  },
  {
    path: '/StarCitizen',
    name: 'StarCitizen',
    component: StarCitizenView
  },
  {
    path: '/IronhedgeRulebook',
    name: 'IronhedgeRulebook',
    component: IronhedgeBook
  },

]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
